import React from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import {Button, Typography} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Error from '@material-ui/icons/Error';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '20px',
    backgroundColor: '#320469',
  },
  heading: {
    color: 'white',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: 4,
    color: theme.palette.grey[500],
  },
});
const DialogContent = withStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 15px',
    border: 0,
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#dfdfdf',
  },
}))(MuiDialogActions);
const useStyles = makeStyles((theme) => ({
  buttonRoot: {
    'lineHeight': 1.75,
    [theme.breakpoints.down('md')]: {
      lineHeight: 1.5,
      padding: '6px 15px !important',
    },
    '& .MuiButton-label': {
      'fontSize': '0.813rem',
      [theme.breakpoints.down('md')]: {
        fontSize: '0.688rem !important',
        letterSpacing: 1,
      },
      '& .MuiSvgIcon-root': {
        [theme.breakpoints.down('md')]: {
          fontSize: '1.1rem !important',
        },
      },
    },
  },
}));
const DialogTitle = withStyles(styles)((props) => {
  const {classes, onClose, ...other} = props;
  return (
    <div className="themeColor">
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h4" className={classes.heading}>
        Work Queue
        </Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={`${classes.closeButton} wq-close-button`}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    </div>
  );
});
const WorkQueueDialog = ({open, handleClose}) => {
  const classes = useStyles();
  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      onClose={handleClose}
      open={open}
      fullWidth
      maxWidth={'sm'}
      className="wq-warning-sec wq-dialog-box"
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        {''}
      </DialogTitle>
      <DialogContent dividers>
        <Error />
        <p style={{fontSize: '18px'}} className="mb-0 ml-1">
          <b>You&apos;ve reached the end of a Work Queue.</b>
        </p>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          color="primary"
          onClick={handleClose}
          variant="contained"
          className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkQueueDialog;
